import type {
    ChatReplyFolderResponse,
    ChatReplyTemplateResponse,
    SaveChatReplyFolderRequest,
    SaveChatReplyTemplateRequest,
} from '@/core/generated/api';
import type { ChatReplyFolderValues, ChatReplyTemplateValues } from './model/schema';

/** Подготавливает поля папки для редактора */
export const chatReplyFolderToValues = (
    folder?: ChatReplyFolderResponse,
    parentId: string | null = null
): ChatReplyFolderValues => ({
    name: folder?.name ?? '',
    parentId: folder?.parentId ?? parentId,
});

/** Подготавливает поля шаблона для редактора */
export const chatReplyTemplateToValues = (
    template?: ChatReplyTemplateResponse,
    folderId = ''
): ChatReplyTemplateValues => ({
    name: template?.name ?? '',
    text: template?.text ?? '',
    folderId: template?.folderId ?? folderId,
});

/** Преобразует поля папки в запрос сохранения */
export const chatReplyFolderToRequest = (
    values: ChatReplyFolderValues,
    version?: string
): SaveChatReplyFolderRequest => ({
    name: values.name.trim(),
    parentId: values.parentId,
    version,
});

/** Преобразует поля шаблона в запрос сохранения */
export const chatReplyTemplateToRequest = (
    values: ChatReplyTemplateValues,
    version?: string
): SaveChatReplyTemplateRequest => ({
    name: values.name.trim(),
    text: values.text,
    folderId: values.folderId,
    version,
});
